import { mapDTO } from '@twistezo/ts-dto-mapper'

import { EditSchema } from '../../../schemas/editSchema'
import { Variables } from './types'

export const toDTO = (from: EditSchema) =>
  mapDTO<EditSchema, Variables>({ from }).transform((data: EditSchema) => {
    const { codeAfter, codeBefore, comment } = { ...data.customCodeAttributes }

    const variables: Variables = {
      ...data,
      customCodeAttributes: data.customCodeEnabled
        ? {
            codeAfter: codeAfter || null,
            codeBefore: codeBefore || null,
            comment: comment || null,
          }
        : null,
    }

    return variables
  })
